import React from 'react';

import styles from './Form.module.scss';

interface FormProps {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  children: React.ReactNode;
  className?: string;
}

export function Form({ onSubmit, children, className = '' }: FormProps) {
  return (
    <form className={`${styles.form} ${className}`} onSubmit={onSubmit}>
      {children}
    </form>
  );
}
